// extracted by mini-css-extract-plugin
export default {"form":"RegistrationForm_form__pfhc2","actionsWrapper":"RegistrationForm_actionsWrapper__0Ke+V"};